export const translations = {
    cookieHeadline: 'Ustawienia ciasteczek',
    cookieButtonAcceptAll: 'Akceptuje wszystkie ciasteczka',
    cookieButtonAcceptEssential: 'Akceptuje niezbędne ciasteczka'
};

export default translations;
